export default {
  INITIATE_PUBLISH_WEBSITE: '@WS_EDITOR/INITIATE_PUBLISH_WEBSITE',
};
